.badge {
  &.badge--error .indicator {
    background-color: var(--rc-theme-color-error-default);
  }

  &.badge--neutral .indicator {
    background-color: var(--rc-theme-color-text-default);
  }

  &.badge--success .indicator {
    background-color: var(--rc-theme-color-success-default);
  }

  &.badge--warning .indicator {
    background-color: var(--rc-theme-color-warning-default);
  }

  &.badge--caution .indicator {
    background-color: var(--rc-theme-color-caution-default);
  }
}

.indicator {
  box-shadow: 0 0 0 1px var(--rc-theme-color-surface-default);
}
